import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('checkcheck_lang');
    if (saved && (saved === 'fr' || saved === 'nl')) {
      return saved;
    }
    // Check browser language
    const browserLang = navigator.language?.split('-')[0];
    return browserLang === 'nl' ? 'nl' : 'fr';
  });

  useEffect(() => {
    localStorage.setItem('checkcheck_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] || translations['fr']?.[key] || key;
  };

  const toggleLang = () => {
    setLang(prev => prev === 'fr' ? 'nl' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
